<template>
	<div class="p-4 w-100 " style="height: 70vh; overflow-y: auto;">
		<div class="w-100 text-center" v-if="!filesystem">
         <span class="mif-spinner2 ani-spin mif-3x"></span>
      </div>
		<div class=" w-100">
			<div v-if="filesystem" class="pos-relative grid">
				<div class="d-flex flex-justify-between flex-align-center">    

					<div class="filter-left">
						<select class="select" @change="changeDrive(filesystem.driveSelected)"
							v-model="filesystem.driveSelected">
							<option :value="drive" v-for="drive in filesystem.drives" v-bind:key="drive">{{
								drive }}\
							</option>
						</select>
					</div>

					<div class="filter-right">
						<a class="button p-2 secondary" href="#" @click="openCreateFolderDialog()">
						{{ $t("Create Folder") }}
						</a>
					</div>
				</div>
				<table class="bg-white border table striped compact overflow">
				<thead>
					<tr>
						<th>{{ $t("File Name") }}</th>
						<th class="text-center">{{ $t("File Size") }}</th>
						<th class="text-right">{{ $t("Date Created") }}</th>
						<th class="text-right">{{ $t("Date Modified") }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-show="filesystem.directorySelected != filesystem.driveSelected">
						<td @dblclick="navigate('up')" :title="filesystem.directorySelected" class="bg-lightgray d-flex flex-align-center p-2 c-pointer">
							<span class="mif-backspace mif-2x" :disabled="waitFileSystem"/>
							<span class="text-bold no-user-select ml-3"> {{ filesystem.directorySelected.split("\\").at(-1) }}\</span>    
						</td>
						<td class="bg-lightgray "></td>
						<td class="bg-lightgray "></td>
						<td class="bg-lightgray "></td>
						<td class="bg-lightgray "></td>
					</tr>
					<tr v-if="filesystem.items == null || waitFileSystem">
						<td class="text-center" colspan="4">
							<span class="mif-spinner2 mif-2x ani-spin mr-2" />
							<span>{{ $t("Retrieving items. Please wait...") }}</span>
						</td>
					</tr>
					<template v-else>
						<tr v-for="item in filesystem.items">
							<td @dblclick="item.type == $FileFolderEntityType.FN_Folder ? navigate(item.path) : null"
							class="c-pointer no-user-select">
							<span class="m-1"
								:class="{ 'mif-folder fg-dark': item.type == $FileFolderEntityType.FN_Folder, 'mif-file-empty': item.type == $FileFolderEntityType.FN_File }" />
							<span :title="item.path" class="c-pointer no-user-select ">
							{{ item.path.split("\\").at(-1) }}
							</span>
							</td>
							<td class="text-center">
							<span v-if="item.type != $FileFolderEntityType.FN_Folder">{{ item.size | prettyBytes }}</span>
							</td>
							<td class="text-right">{{ item.creationDate.toLocalDate() }}</td>
							<td class="text-right">{{ item.modificationDate.toLocalDate() }}</td>
						</tr>
					</template>
				</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import { ClientTreeNode } from '../../models/TreeNode';
import { prettyBytes } from '../../utils/utilitiesmodule';


export default {
	name: "FileExplorer",
	components: {},
	data() {
		return {
			status: this.$ResultValue.Running,
			filesystem: null,
			waitFileSystem: false,
			//Si riferisce alla classe ExploreFSOptions dell'agent
			exploreFSOptions: {
				includeFiles: true,
				includeHiddenFiles: false,
				includeInaccessibleFiles: false,
				includeSystemFiles: false,
				includeDetails: true
			},
		}
	},
	beforeDestroy() {
		this.$root.$off("renameitemfeedback");
		this.$root.$off("deleteitemfeedback");
	},
	methods: {

		getFileSystem() {

			var requestData={
				nodeID: "",
				path: "C:",
				options: this.exploreFSOptions
			};
			this.$root.socket("GetExploreFs", requestData).then(response => this.GetExploreFsCallback(response));


			this.$root.$on("renameitemfeedback", async itemRenamed => {
				if (!itemRenamed)
					return;
				var requestData={
					nodeID: "",
					path: this.filesystem.directorySelected,
					options: this.exploreFSOptions
				};
				this.GetExploreFsCallback(await this.$root.socket("GetExploreFs", requestData));
			});

			this.$root.$on("deleteitemfeedback", async itemDeleted => {
				if (!itemDeleted)
					return;
				var requestData={
					nodeID: "",
					path: this.filesystem.directorySelected,
					options: this.exploreFSOptions
				};
				this.GetExploreFsCallback(await this.$root.socket("GetExploreFs", requestData));
			});
		},

		async navigate(directory) {
			if (this.waitFileSystem)
				return;
			this.waitFileSystem=true;
			let self=this;
			var requestData;
			if (directory=="up") {
				self.filesystem.directorySelected=self.filesystem.path[self.filesystem.path.length-1];
				self.filesystem.path.pop();
				requestData={
					nodeID: "",
					path: self.filesystem.directorySelected,
					options: this.exploreFSOptions
				};
			} else {
				self.filesystem.path.push(self.filesystem.directorySelected);
				self.filesystem.directorySelected=directory;
				requestData={
					nodeID: "",
					path: directory,
					options: this.exploreFSOptions
				};
			}
			self.GetExploreFsCallback(await self.$root.socket("GetExploreFs", requestData));
			this.waitFileSystem=false;
		},

		async changeDrive(drive) {
			let self=this;
			self.filesystem.path=[];
			self.filesystem.driveSelected=drive;
			self.filesystem.directorySelected=drive;
			self.filesystem.files=[];
			self.filesystem.directories=[];
			var requestData={
				nodeID: "",
				path: self.filesystem.driveSelected,
				options: this.exploreFSOptions
			};
			self.$root.socket("GetExploreFs", requestData).then(result => self.GetExploreFsCallback(result));
		},

		//filesystem è una oggetto:
		//{
		//    drives : //lista di stringhe, 
		//    items: //lista di ClientTreeNode
		//}
		GetExploreFsCallback(filesystem) {

			let self=this;
			if (filesystem==null) {

				self.filesystem={
					drives: [],
					items: [],
					driveSelected: "C:",
					path: [],
					directorySelected: "C:",
				};
				return;
			}

			if (self.filesystem==null) {

				self.filesystem={
					drives: filesystem.drives,
					items: filesystem.items,
					driveSelected: "C:",
					path: [],
					directorySelected: "C:",
				};
				return;
			}

			if (filesystem.drives==null||filesystem.drives.length==0) {
				this.waitFileSystem=false;
				self.navigate("up");
				return;
			}

			self.filesystem.drives=filesystem.drives;
			self.filesystem.items=filesystem.items;
		},

		openRenameItemDialog(path, type) {
			var node=new ClientTreeNode(null, null, path, type);
			this.$root.$emit("OPENRENAMEITEMDIALOG", node, this.filesystem.directorySelected);
		},

		openCreateFolderDialog() {
			var createFolderObj={
				parentPath: this.filesystem.directorySelected,
				name: "",
				client: null, // il tipo FileFolder non ha client
				mainFolders: this.filesystem.drives /*.map(d => d.trimEnd('\\'))*/
			}
			let self=this;
			this.$root.$on("createitemfeedback", newNodes => {
				if (newNodes!=null) {
					self.filesystem.items.push(...newNodes);
				}
				self.$root.$off("createitemfeedback");
			});
			this.$root.$emit('OPENCREATEFOLDERDIALOG', createFolderObj);
		},

	},
	filters: {
		prettyBytes: function(bytes, precision) {
			return prettyBytes(bytes, precision);
		},
	},
}
</script>
